import React, { useState } from "react";
import { Select, Tag, message } from "antd";
import rewardProgramApi from "../../../api/rewardProgramApi";

// CHỈ TikTok. Shopee/Lazada dán link ra thẳng shopId; hơn nữa tìm theo tên cho Shopee
// đã đo mất 107 giây trên prod (xem services/reward-program/admin-shop-search.js).
const CAMP_ID = "tiktok";

/**
 * reward-shop-search-picker — chọn shop bằng cách gõ TÊN, tìm trong đơn đã crawl.
 *
 * Bắt buộc cho TikTok: mã shop (`shop_code`) chỉ nằm trong dữ liệu đơn, không link
 * nào bóc ra được. Shopee/Lazada KHÔNG dùng ô này — dán link ra thẳng shopId, và tìm
 * theo tên cho Shopee đo được 107 giây trên prod nên backend đã chặn.
 *
 * Chỉ tìm trong ~180 ngày gần nhất (bảng Items rất lớn) → shop chưa từng có đơn
 * trong khoảng đó sẽ không hiện.
 */
function RewardShopSearchPicker({ onPick }) {
    const [options, setOptions] = useState([]);
    const [fetching, setFetching] = useState(false);

    const handleSearch = async (q) => {
        if (!q || q.trim().length < 2) return setOptions([]);
        setFetching(true);
        try {
            const { data } = await rewardProgramApi.searchShops(CAMP_ID, q.trim());
            setOptions(
                (data.shops || []).map((s) => ({
                    // shopId có thể NULL (đơn TikTok nguồn RioHub chỉ có tên) → khoá theo tên.
                    value: `${s.shopId || ""}|${s.shopName || ""}`,
                    label: `${s.shopName || "(không tên)"} — ${s.orderCount} đơn${s.shopId ? "" : " · chưa có mã shop"}`,
                    shop: s,
                }))
            );
        } catch (err) {
            message.error(err?.response?.data?.message || "Không tìm được shop");
        } finally {
            setFetching(false);
        }
    };

    const handleSelect = (_, option) => {
        const s = option.shop;
        onPick({ campId: CAMP_ID, shopId: s.shopId || null, name: s.shopName || null, url: null });
        setOptions([]);
    };

    return (
        <div className="flex items-center gap-2 w-full">
            <Tag color="magenta">TikTok</Tag>
            <Select
                showSearch filterOption={false} value={null}
                placeholder="Gõ tên shop TikTok để tìm trong đơn đã có (link TikTok không chứa mã shop)"
                notFoundContent={fetching ? "Đang tìm…" : null}
                onSearch={handleSearch} onSelect={handleSelect}
                options={options} style={{ flex: 1 }}
            />
        </div>
    );
}

export default RewardShopSearchPicker;
